/* global Stimulus */
console.log("template0/book.js Loaded");

//* Stimulus
import TextareaAutogrow from "stimulus-textarea-autogrow";
Stimulus.register("textarea-autogrow", TextareaAutogrow);

import formvalidation_booking from "../../view_components/formvalidation/booking/index.js";
Stimulus.register("formvalidation--booking", formvalidation_booking);

import copyable_input from "../../view_components/copyable_input/index.js";
Stimulus.register("copyable-input", copyable_input);

import autosubmit_form_on_recaptcha from "../../view_components/autosubmit_form_on_recaptcha/index.js";
Stimulus.register("autosubmit-form-on-recaptcha", autosubmit_form_on_recaptcha);

import touchspin from "../../view_components/touchspin/index.js";
Stimulus.register("touchspin", touchspin);

import easepick from "../../view_components/easepick/index.js";
Stimulus.register("easepick", easepick);

import character_counter from "../../view_components/character_counter/index.js";
Stimulus.register("character-counter", character_counter);

import intl_tel_input from "../../view_components/intl_tel_input/index.js";
Stimulus.register("intl-tel-input", intl_tel_input);

import recaptcha_v2 from "../../view_components/recaptcha_v2/index.js";
Stimulus.register("recaptcha-v2", recaptcha_v2);

import scroll_to from "../../view_components/scroll_to/index";
Stimulus.register("scroll-to", scroll_to);

import confetti from "../../view_components/confetti/index.js";
Stimulus.register("confetti", confetti);

import validation_fixes from "../../view_components/validation_fixes/index.js";
Stimulus.register("validation-fixes", validation_fixes);
